import { forwardRef } from 'react';

export const MarketTrendIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg
        ref={ref}
        width="49"
        height="48"
        viewBox="0 0 49 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_5184_347)">
          <path
            d="M13.8 29.2504L19.5 25.8504L24.05 29.6504L34.35 22.4004"
            stroke="#004B54"
            strokeWidth="2.17"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M33.8 25.7512L34.7001 21.9512L30.8 22.0512"
            stroke="#004B54"
            strokeWidth="2.17"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M40.2999 11.3008V36.7008H8.69995V11.3008H40.2999Z"
            stroke="#004B54"
            strokeWidth="2.17"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.69995 16.2012H37.9"
            stroke="#004B54"
            strokeWidth="2.17"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.25 14.5492C11.6918 14.5492 12.05 14.191 12.05 13.7492C12.05 13.3074 11.6918 12.9492 11.25 12.9492C10.8081 12.9492 10.45 13.3074 10.45 13.7492C10.45 14.191 10.8081 14.5492 11.25 14.5492Z"
            fill="#004B54"
          />
          <path
            d="M13.9001 14.5492C14.3419 14.5492 14.7001 14.191 14.7001 13.7492C14.7001 13.3074 14.3419 12.9492 13.9001 12.9492C13.4583 12.9492 13.1001 13.3074 13.1001 13.7492C13.1001 14.191 13.4583 14.5492 13.9001 14.5492Z"
            fill="#004B54"
          />
          <path
            d="M16.55 14.5492C16.9918 14.5492 17.35 14.191 17.35 13.7492C17.35 13.3074 16.9918 12.9492 16.55 12.9492C16.1082 12.9492 15.75 13.3074 15.75 13.7492C15.75 14.191 16.1082 14.5492 16.55 14.5492Z"
            fill="#004B54"
          />
        </g>
        <defs>
          <clipPath id="clip0_5184_347">
            <rect width="48" height="48" fill="white" transform="translate(0.5)" />
          </clipPath>
        </defs>
      </svg>
    );
  },
);
